module.exports = __webpack_public_path__ + "img/01.d989220d.png";